Number.prototype.addVat = function (percent) {
    return this * ((percent / 100) + 1);
};
Number.prototype.toFixedNumber = function (precision) {
    var rounder = Math.pow(10, precision);
    return Math.round(this * rounder) / rounder;
};
Number.prototype.toPrettyNumber = function (precision, locale) {
    return this.toLocaleString(locale ? locale : 'sv-SE', { useGrouping: true, maximumFractionDigits: precision }).replace(",", ".");
};
Number.prototype.toFixedNotRounded = function (precision) {
    var expression = new RegExp('^-?\\d+(?:\.\\d{0,' + (precision || -1) + '})?');
    return this.toString().match(expression)[0];
};
